export default __webpack_public_path__ + "static/media/P620_RoHS.90d346a1.pdf";